import CodeSnippet from 'components/CodeSnippet';
import * as CODE from "../../../../src/constants/conversations";
import * as React from 'react';
export default {
  CodeSnippet,
  CODE,
  React
};